import { render } from "./v-addFaq.vue?vue&type=template&id=81b90dc0&scoped=true"
import script from "./v-addFaq.vue?vue&type=script&lang=js"
export * from "./v-addFaq.vue?vue&type=script&lang=js"

import "./v-addFaq.vue?vue&type=style&index=0&id=81b90dc0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-81b90dc0"

export default script